<template>
  <UserShell
    title="资产评估"
    subtitle="填写主播运营数据及证明材料，提交后台审核评估"
    :profile="profile"
    :menu-items="menuItems"
    active-key="asset"
    center-path="/user/org"
  >
    <div class="notice-box">
      <img class="notice-icon" :src="tipIcon" alt="提示" />
      <span>评估时间为2个工作日；评估通过后，专员将在3个工作日内电话联系你；联系电话：17882361794</span>
    </div>

    <div class="toolbar">
      <div class="search-group">
        <el-input v-model.trim="keyword" placeholder="请输入编号/类型/状态" class="search-input" @keyup.enter.native="handleSearch" />
        <button type="button" class="search-btn" @click="handleSearch">搜索</button>
      </div>
      <button type="button" class="new-btn" @click="goCreate">{{ activeDraft ? '继续编辑' : '+ 新增评估' }}</button>
    </div>

    <div class="table-wrap">
      <table class="asset-table">
        <thead>
          <tr>
            <th>申请编号</th>
            <th>资产名称</th>
            <th>资产类别</th>
            <th>提交时间</th>
            <th>当前状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in filteredList" :key="item.id">
            <td>{{ item.applicationNo }}</td>
            <td class="asset-name">{{ item.assetName }}</td>
            <td>{{ item.assetCategory }}</td>
            <td>{{ item.submittedAt }}</td>
            <td><span :class="['status-pill', statusClassMap[item.status] || 'draft']">{{ item.statusLabel }}</span></td>
            <td>
              <div class="action-group">
                <button v-for="action in getActions(item)" :key="action.label" type="button" :class="['table-btn', action.type]" @click="handleAction(action.key, item)">{{ action.label }}</button>
              </div>
            </td>
          </tr>
          <tr v-if="!filteredList.length"><td colspan="6" class="empty-cell">暂无评估记录</td></tr>
        </tbody>
      </table>
    </div>
    <div v-if="total > perPage" class="pagination-row">
      <el-pagination
        background
        layout="prev, pager, next, jumper"
        :current-page="page"
        :page-size="perPage"
        :total="total"
        @current-change="handlePageChange"
      />
    </div>
  </UserShell>
</template>

<script>
import UserShell from './components/UserShell.vue';
import sidebarBg from '@/assets/img/user/背景卡图.png';
import userAvatar from '@/assets/img/user/avatar.png';
import overviewActiveIcon from '@/assets/img/user/griconxz.png';
import overviewActiveIconIn from '@/assets/img/user/gricon.png';
import talentActiveIcon from '@/assets/img/user/zbglxz.png';
import talentInactiveIcon from '@/assets/img/user/zbgl.png';
import assetActiveIcon from '@/assets/img/user/申请icon.png';
import assetInactiveIcon from '@/assets/img/user/申请未选中.png';
import tipIcon from '@/assets/img/user/提示.png';
import { getMemberProfile } from '@/api/user';
import { getOrganizationAssetApplications } from './organizationAssetStore';
import { downloadFile } from '@/utils/download';

function createMenu() {
  return [
 { key: 'overview', label: '首页概览', path: '/user/org', activeIcon: overviewActiveIcon,inactiveIcon: overviewActiveIconIn},
 { key: 'talent', label: '主播管理', path: '/user/org/talents', activeIcon: talentActiveIcon, inactiveIcon: talentInactiveIcon },
 { key: 'asset', label: '资产评估申请', path: '/user/org/assets', activeIcon: assetActiveIcon, inactiveIcon: assetInactiveIcon }
  ];
}

function extractResponseData(response) {
  return response && response.data ? response.data : {};
}

export default {
  name: 'OrganizationAssetApplication',
  components: { UserShell },
  data() {
    return {
      tipIcon,
      profile: {
        name: '星辰传媒有限公司',
        role: 'MCN机构',
        avatar: userAvatar,
        background: sidebarBg
      },
      menuItems: createMenu(),
      keyword: '',
      searchKeyword: '',
      records: [],
      activeDraft: null,
      page: 1,
      perPage: 15,
      total: 0,
      statusClassMap: {
        rejected: 'rejected',
        approved: 'approved',
        pending: 'reviewing',
        draft: 'draft'
      }
    };
  },
  computed: {
    filteredList() {
      if (!this.searchKeyword) {
        return this.records;
      }
      const keyword = this.searchKeyword.toLowerCase();
      return this.records.filter(item => [item.applicationNo, item.assetCategory, item.status, item.statusLabel, item.assetName].some(field => String(field || '').toLowerCase().includes(keyword)));
    }
  },
  created() {
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      try {
        await this.fetchProfile();
        const result = await getOrganizationAssetApplications({
          page: this.page,
          per_page: this.perPage
        });
        this.records = result.items;
        this.activeDraft = result.activeDraft;
        this.total = result.total;
        this.page = result.currentPage;
        this.perPage = result.perPage;
      } catch (error) {
        this.records = [];
        this.activeDraft = null;
        this.total = 0;
        this.$message.error(error && error.message ? error.message : '获取评估列表失败');
      }
    },
    async fetchProfile() {
      try {
        const profileResponse = await getMemberProfile();
        const profileData = extractResponseData(profileResponse);
        this.profile = {
          ...this.profile,
          name: profileData.name || this.profile.name,
          role: profileData.type_text || this.profile.role,
          avatar: profileData.avatar || this.profile.avatar
        };
      } catch (error) {
        void error;
      }
    },
    handleSearch() {
      this.searchKeyword = this.keyword;
    },
    getActions(item) {
      if (item.status === 'rejected') {
        return [{ key: 'edit', label: this.isEditingItem(item) ? '继续编辑' : '修改', type: 'primary wide' }];
      }
      if (item.status === 'draft') {
        return [{ key: 'edit', label: '继续编辑', type: 'primary wide' }];
      }
      if (item.status === 'approved') {
        const actions = [
          { key: 'view', label: '查看', type: 'ghost' }
        ];
        if (item.reportUrl) {
          actions.push({ key: 'download', label: '下载报告', type: 'ghost wide' });
        }
        return actions;
      }
      return [{ key: 'view', label: '查看', type: 'ghost' }];
    },
    isEditingItem(item) {
      return Boolean(
        this.activeDraft &&
        this.activeDraft.reportChainId &&
        item.reportChainId &&
        String(item.reportChainId) === String(this.activeDraft.reportChainId)
      );
    },
    async handleAction(action, item) {
      if (action === 'edit') {
        if (this.activeDraft && !this.isEditingItem(item)) {
          this.$message.warning('您有未完成的草稿（另一条评估），请先提交或放弃');
          return;
        }
        this.$router.push({ path: '/user/org/assets/create', query: { source_evaluation_id: String(item.id) } });
        return;
      }
      if (action === 'view') {
        this.$router.push({ path: '/user/org/assets/create', query: { mode: 'view', id: String(item.id) } });
        return;
      }
      if (action === 'download') {
        if (!item.reportUrl) {
          this.$message.warning('评估报告暂未生成');
          return;
        }
        try {
          await downloadFile(item.reportUrl, `${item.applicationNo}-资产评估报告`);
        } catch (error) {
          this.$message.error(error && error.message ? error.message : '报告下载失败，请稍后重试');
        }
      }
    },
    handlePageChange(nextPage) {
      this.page = nextPage;
      this.loadRecords();
    },
    goCreate() {
      if (this.activeDraft) {
        this.$router.push('/user/org/assets/create');
        return;
      }
      this.$router.push('/user/org/assets/create');
    }
  },
  watch: {
    '$route.fullPath'() {
      this.loadRecords();
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-box {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 24px;
  padding: 12px 18px;
  border: 1px solid #a89eff;
  border-radius: 12px;
  background: rgba(111, 104, 243, 0.04);
  color: #6f68f3;
  font-size: 15px;
}

.notice-icon {
  width: 20px;
  height: 20px;
}

.toolbar,
.search-group,
.action-group {
  display: flex;
  align-items: center;
  gap: 14px;
  justify-content: center;
}

.toolbar {
  justify-content: space-between;
  margin-top: 48px;
}

.search-input {
  width: 274px;
}

.search-input ::v-deep .el-input__inner {
  height: 40px;
  border-radius: 8px;
  border: 1px solid #eef1f7;
  background: #f8fafc;
}

.search-btn,
.new-btn,
.table-btn {
  border: 0;
  border-radius: 8px;
  cursor: pointer;
}

.search-btn,
.new-btn,
.table-btn.primary {
  background: #6f68f3;
  color: #fff;
}

.search-btn {
  width: 90px;
  height: 40px;
}



.new-btn {
  min-width: 110px;
  height: 40px;
  padding: 0 16px;
}

.table-wrap {
  margin-top: 30px;
  border: 1px solid #d9dfeb;
  border-radius: 14px;
  overflow: hidden;
}

.pagination-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.asset-table {
  width: 100%;
  border-collapse: collapse;
}

.asset-table th,
.asset-table td {
 height: 54px;
 padding: 0 10px;
 border-bottom: 1px solid #d6d7d9;
 text-align: center;
 font-size: 14px;
 color: #1E293B;
}


.asset-table thead tr {
 background: #F8FAFC;
 height: 45px;
}

.asset-table th {
  height: 45px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 15px;
  color: #64748B;
  line-height: 20px;
}

.asset-table tbody tr:last-child td {
  border-bottom: 0;
}

.asset-name {
  color: #4F46E5 !important;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 76px;
  height: 32px;
  padding: 0 14px;
  border-radius: 999px;
}

.rejected {
  color: #ED2D2D;
  font-size: 13px;
  width: 70px;
  height: 30px;
  background: #FFDCDC;
  border-radius: 50px 50px 50px 50px;
}

.approved {
  width: 70px;
  height: 30px;
  background: #ECFDF5;
  border-radius: 50px 50px 50px 50px;
  color: #059669;
  font-size: 13px;
}

.reviewing {
  width: 70px;
  height: 30px;
  background: #DEE8FF;
  border-radius: 50px 50px 50px 50px;
  color: #2564F6;
  font-size: 13px;
}

.draft {
  background: #f3f4f8;
  color: #6b7280;
}

.table-btn {
  min-width: 58px;
  height: 31px;
  font-size: 13px;
  border-radius: 6px;
}

.table-btn.ghost {
  background: #E6F2FF;
  color: #2564F6;
}

.table-btn.wide {
  min-width: 92px;
  background: rgba(79,70,229,0.06);
  color: #4F46E5;
}

.empty-cell {
  color: #98a2b3;
}

@media (max-width: 760px) {
  .toolbar,
  .search-group {
    flex-direction: column;
    align-items: flex-start;
  }

  .table-wrap {
    overflow-x: auto;
  }

  .asset-table {
    min-width: 780px;
  }
}
</style>
